import { useLocation } from 'react-router-dom'
import BackButton from "../common/BackButton"
import useStore from '../../store'
import { useNavigate } from 'react-router-dom'
import useUserType from '../../hooks/useUserType'

export default function NavBarBackButton({ styles }) {
  const pathname = useLocation().pathname
  const breadcrumbTrail = useStore((state) => state.breadcrumbTrail)
  const setBreadcrumbTrail = useStore((state) => state.setBreadcrumbTrail)
  const setDashboardUnitId = useStore((state) => state.setDashboardUnitId)
  const navigate = useNavigate()
  const { isEmployee } = useUserType()

  const handleBack = () => {
    if (isEmployee) {
      if (breadcrumbTrail.length > 0) {
        setBreadcrumbTrail(breadcrumbTrail.slice(0, -1))
      }
      setDashboardUnitId(null)
    }
    if (window.history.length <= 1) {
      navigate('/')
    } else {
      window.history.back()
    }
  }

  return(
    <>
      {pathname !== '/' &&
        <BackButton styles={styles} onClick={handleBack} />
      }
    </>
  )
}